import { Capacitor } from "@capacitor/core";

const isLocalDev =
  !Capacitor.isNativePlatform() &&
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

// No Azure fallbacks. These used to default to the Azure endpoints, so a build
// that forgot to inject the env vars silently talked to Azure while the CSP (or
// the operator) expected Scaleway — which is exactly how login broke. Dev falls
// back to localhost; every other build MUST provide the URL explicitly.
export const AUTH_API_URL =
  process.env.REACT_APP_AUTH_API_URL || (isLocalDev ? "http://localhost:5002" : "");

export const BACKEND_MAIN_URL =
  process.env.REACT_APP_BACKEND_MAIN_URL || (isLocalDev ? "http://localhost:5001" : "");

// Local CRM tests can use a separate API while chat/login stay on staging.
export const CRM_API_URL = process.env.REACT_APP_CRM_API_URL || BACKEND_MAIN_URL;
export const CRM_DEMO_MODE = process.env.REACT_APP_CRM_DEMO_MODE === 'true';

if (!AUTH_API_URL || !BACKEND_MAIN_URL) {
  // Loud, early failure beats mysterious CORS/CSP errors later.
  console.error(
    "[config] REACT_APP_AUTH_API_URL / REACT_APP_BACKEND_MAIN_URL are not set. " +
    "API calls will fail. Set them at build time."
  );
}
